// Spec 2.10: the grid's page-wide keys (Delete, Ctrl+A, Escape) act only when the key
// lands on the page body or inside the grid's own container, never in the Copilot pane.
export const isGridKeyTarget = (target: EventTarget | null, grid: HTMLElement | null): boolean => {
  if (!target) {
    return false;
  }
  if (target === document.body) {
    return true;
  }
  return !!grid && target instanceof Node && grid.contains(target as Node);
};
